import { render } from "./index.vue?vue&type=template&id=6c5c56aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=6c5c56aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c5c56aa"

export default script